export default __webpack_public_path__ + "static/media/m_engineering_card22_2.e4b3ef54.png";